var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "glossary" }, [
    _c(
      "div",
      { staticClass: "glossary-inner" },
      [
        _c("h1", { staticClass: "heading" }, [_vm._v("Glossar")]),
        _vm._v(" "),
        _c(
          "dl",
          _vm._l(Object.keys(_vm.definitions).sort(), function(index) {
            return _c("div", { staticClass: "glossary-group" }, [
              _c("div", { staticClass: "glossary-group-index" }, [
                _c("h2", { staticClass: "glossary-index" }, [
                  _vm._v(_vm._s(index))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "glossary-group-items" },
                [
                  _vm._l(_vm.definitions[index], function(definition) {
                    return [
                      _c(
                        "dt",
                        {
                          attrs: {
                            id: definition["glossary_content_anchor_id"]
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "#" + definition["glossary_content_anchor_id"]
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.handleAnchorClick(
                                    definition["glossary_content_anchor_id"]
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(definition["glossary_content_term"]) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("dd", {
                        domProps: {
                          innerHTML: _vm._s(
                            definition["glossary_content_definition"]
                          )
                        }
                      })
                    ]
                  })
                ],
                2
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("ReferenzComponent", {
          attrs: { referenzenList: _vm.referenceData.referenzen_list }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-726ea399", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726ea399","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/Glossary.vue
// module id = 605
// module chunks = 0